import React from "react";

const Input = ({ name, label, value, disabled, onChange, required, error, hint, widthSize, alignSelf, textAlign }) => {
    return (
        <>
            <label htmlFor={`input-${name}`} className={`${required ? "input-required" : ""}`}>
                {label}
            </label>
            <input
                style={{width: widthSize, alignSelf: alignSelf, textAlign: textAlign }}
                type="text"
                name={name}
                id={`input-${name}`}
                value={value}
                onChange={onChange}
                className={`input-disabled ${disabled ? "inactive" : ""} `}
                disabled={disabled}
            />
            {hint && <div className="hint-message-text">{hint}</div>}
            {error && <div className="error-message-text">{error}</div>}
        </>
    );
};

export default Input;
